import { combineReducers } from 'redux';

import blogGetAll from './blog/get-all/reducer';
import globals from './globals/reducer';
import mediaGetAll from './media/get-all/reducer';
import questionsGetAll from './questions/get-all/reducer';
import questionsCategoryOptions from './questions/category-options/reducer';
import responsesGetAll from './responses/get-all/reducer';
import uiQuestions from './ui/questions/reducer';

export default combineReducers({
  blogGetAll,
  globals,
  mediaGetAll,
  questionsGetAll,
  questionsCategoryOptions,
  responsesGetAll,
  uiQuestions,
});



// WEBPACK FOOTER //
// ./src/redux/reducers.js